import React from 'react';

import Permissions from 'components/Permissions';
import {
  REQUEST_READ_SELF,
  REQUEST_READ_ALL,
  REQUEST_CREATE,
  ACCOUNTS_CAN_MANAGE_USER,
  CAN_UPDATE_FEATURES,
  CAN_UPDATE_TEMPLATE,
  CAN_MANAGE_ACTIVITIES,
  CAN_EDIT_CMS,
} from 'helpers/permissionsHelpers';

export const withPermissions = WrappedComponent => props => (
  <Permissions
    groups={['staff']}
  >
    {isStaff => (
      <Permissions
        permissions={[REQUEST_READ_SELF, REQUEST_READ_ALL]}
      >
        {canReadRequests => (
          <Permissions
            permissions={[REQUEST_CREATE]}
          >
            {canCreateRequests => (
              <Permissions
                permissions={[ACCOUNTS_CAN_MANAGE_USER]}
              >
                {canManageUsers => (
                  <Permissions
                    permissions={[CAN_UPDATE_FEATURES]}
                  >
                    {canUpdateFeatures => (
                      <Permissions
                        permissions={[CAN_UPDATE_TEMPLATE]}
                      >
                        {canUpdateTemplate => (
                          <Permissions
                            permissions={[CAN_MANAGE_ACTIVITIES]}
                          >
                            {canManageActivities => (
                              <Permissions
                                permissions={[CAN_EDIT_CMS]}
                              >
                                {canEditCMS => (
                                  <WrappedComponent
                                    permissions={{
                                      isStaff,
                                      canReadRequests,
                                      canCreateRequests,
                                      canManageUsers,
                                      canUpdateFeatures,
                                      canManageActivities,
                                      canAccessAdmin:
                                          canManageUsers
                                        || canUpdateFeatures
                                        || canManageActivities,
                                      canUpdateTemplate,
                                      canEditCMS,
                                    }}
                                    {...props}
                                  />
                                )}
                              </Permissions>
                            )}
                          </Permissions>
                        )}
                      </Permissions>
                    )}
                  </Permissions>
                )}
              </Permissions>
            )}
          </Permissions>
        )}
      </Permissions>
    )}
  </Permissions>
);

export default withPermissions;



// WEBPACK FOOTER //
// ./src/components/Layout/Header/withHeaderPermissions.js